import React from 'react';
import PropTypes from 'prop-types';
import { Container } from 'react-bootstrap';

import { InfoMessage, LoadingStatusWrapper, PopOutChart } from 'sharedComponents';
import { apiCallStatus } from 'helpers/constants';
import useChartConfig, { chartPlugins } from './useChartConfig';
import { crossAssetTrendsContainerId } from './constants';
import { paramListForChartDataRequest } from '../../helpers';
import { EmptyComparisonMessage } from '../EmptyComparisonMessage';

import '../style.scss';
import { EnableUniqueScaling, PopOutButton, ResetZoomButton, withLeftButtonGroup, withPopOutRow, withRightButtonGroup } from 'sharedComponents/Chart/headers';

const TrendComponent = ({
    chartData,
    removeKPIData,
    selectedKPIType,
    chartLoadingStatus,
    chartErrorData,
    setIsZoomed,
    zoomInToSelectedTrendKpiData,
    resetChartData,
    isComparisonView,
    offGraphSignalsCount,
    model: { enableUniqueScaling, isZoomed } }
) => {
    const zoomInServer = (from, to) => {
        const list = paramListForChartDataRequest(chartData, selectedKPIType);
        zoomInToSelectedTrendKpiData(list, true, from, to, selectedKPIType);
    };

    const resetServerZoom = () => {
        const list = paramListForChartDataRequest(chartData, selectedKPIType);
        resetChartData(list, selectedKPIType);
    };

    const chartOptions = useChartConfig(chartData, removeKPIData);

    const CustomChartHeader = withPopOutRow([
        withLeftButtonGroup([EnableUniqueScaling]),
        withRightButtonGroup([ResetZoomButton, PopOutButton])]);

    const renderNoKpiContent = () => {
        if (chartErrorData?.loadingStatus === apiCallStatus.ERROR) {
            return <InfoMessage
                title='ABB.Powertrain.Frontend.errorBoundaryMessageTitle500'
                text='ABB.Powertrain.Frontend.errorBoundaryMessageDesc500' />;
        }
        if (isComparisonView) {
            return <EmptyComparisonMessage offGraphSignalsCount={offGraphSignalsCount} />;
        }
        return <InfoMessage
            title='ABB.Powertrain.Frontend.chartNoKPIsSelected'
            text='ABB.Powertrain.Frontend.chartNoKPIsSelectedUserGuide' />;
    };

    return (
        <Container fluid className='cross-asset-chart-container'>
            <LoadingStatusWrapper
                useCustomAnchor
                transparent
                loadingStatus={chartLoadingStatus}>
                <PopOutChart
                    hasKpi={!!chartData?.length}
                    renderNoKpi={renderNoKpiContent}
                    loadingStatus={chartLoadingStatus}
                    enableUniqueScaling={enableUniqueScaling}
                    options={chartOptions}
                    modules={chartPlugins}
                    container={crossAssetTrendsContainerId}
                    isZoomed={isZoomed}
                    setIsZoomed={setIsZoomed}
                    zoomInServer={zoomInServer}
                    resetServerZoom={resetServerZoom}
                    mainChartHeader={CustomChartHeader}
                    isTrendSignal={true}
                />
            </LoadingStatusWrapper>
        </Container>
    );
};

TrendComponent.propTypes = {
    chartData: PropTypes.shape({
        length: PropTypes.number,
    }),
    removeKPIData: PropTypes.func,
    selectedKPIType: PropTypes.number,
    chartLoadingStatus: PropTypes.string,
    chartErrorData: PropTypes.object,
    setIsZoomed: PropTypes.func,
    zoomInToSelectedTrendKpiData: PropTypes.func,
    resetChartData: PropTypes.func,
    isComparisonView: PropTypes.bool,
    offGraphSignalsCount: PropTypes.number,
    model: PropTypes.shape({
        enableUniqueScaling: PropTypes.bool,
        isZoomed: PropTypes.bool
    })
};

export default TrendComponent;
